export const maxWords = (value: string, max: number) => {
  const words = value.trim().split(' ');
  return words.length <= max;
};

export const characterLimit = (value: string, max: number) => value.trim().length <= max;
